import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchAiTheme, updatePromptCreationData } from "actions/promptEditor";
import { getBaseUrl } from "services/util";


import { Button } from "react-bootstrap";
import Placeholder from "react-bootstrap/Placeholder";
import _ from "lodash";
import cx from "classnames";
import { useHistory, useRouteMatch, useParams } from "react-router-dom";

import { DraggableAccordionSections } from "../../components/storyLineRender";

import FooterStep from "../../components/footerStep";

import { Sparkle } from "../../components/sparkle";

import styles from "./storyLineStep.module.scss";

export default function StoryLineStep({ onBack, updateStep }) {
    const dispatch = useDispatch();
    const history = useHistory();
    let { url } = useRouteMatch();
    let baseUrl = getBaseUrl(url);
    const { listId } = useParams();
    const outline = useSelector(state => _.get(state.promptEditor, "data.pageStructure.sections", []));
    const loading = useSelector(state => _.get(state.promptEditor, "loading", false));
    const aiTheme = useSelector(state => _.get(state.promptEditor, "templates.items", []));
    const themeLoading = useSelector(state => _.get(state.promptEditor, "templates.loading", false));
    const sectionData = useSelector(state => _.get(state, 'promptEditor.data', []));
    const storyboardName = _.get(sectionData, "storyboardName", "prompt based editor");
    const pageName = _.get(sectionData, "pageName", "prompt based editor");
    const isLoading = loading || !outline || (outline && _.size(outline) === 0);

    const handleContinue = () => {
        localStorage.setItem('promptEditorData', JSON.stringify(sectionData));
        localStorage.setItem('aiTheme', JSON.stringify(aiTheme));
        // const name = encodeURIComponent('prompt based editor');
        const templateUrl = `${baseUrl}/storyboards/templates/blank_landing_page_template/create?name=${storyboardName}${listId ? `&list=${listId}` : ''}&isPromptEditor=true`;
    
        const win = window.open(templateUrl, "_blank");
        win.focus();
        const url = listId
            ? `${baseUrl}/storyboards/folder/${listId}`
            : `${baseUrl}/storyboards`;
        history.push(url); 
    }
    

    const loadingContent = ['Analysing Content...', 'Building Structure...', 'Outlining Chapters', 'Analysing Content...'];

    // Show loader if loading or storyLine is not available
    if (isLoading) {
        return (
            <div className={styles.storyLineStep}>
                <div className={styles.loaderContainer}>
                    <div className={styles.loaderContent}>
                        {/* Header with sparkle icon and text */}
                        <div className={styles.loaderHeaderWrapper}>
                           <Sparkle width={30} height={30} />
                            <div className={styles.loaderHeaderBlock}>
                                <div className={styles.loaderHeader}>
                                {loadingContent.map((content) => (
                                    <span className={styles.loaderTitle}>{content}</span>
                                ))}
                                </div>
                            </div>
                        </div>

                        {/* Main title placeholder */}
                        <div className={styles.titlePlaceholder}>
                            <Placeholder animation="wave">
                                <Placeholder xs={12} size="lg" />
                            </Placeholder>
                            <Placeholder animation="wave">
                                <Placeholder xs={6} size="xs" />
                            </Placeholder>
                        </div>


                        {/* Content block placeholders with dividers */}
                        {_.times(3, (index) => (
                            <div key={index} className={styles.contentPlaceholders}>
                                <Placeholder animation="wave">
                                    <Placeholder xs={1} size="xs" /> <Placeholder xs={10} size="xs" />
                                </Placeholder>
                                <div className={styles.blockContent}>
                                    <Placeholder animation="wave">
                                        <Placeholder xs={12} style={{ height: '82px' }} />
                                    </Placeholder>
                                </div>
                            </div>
                        ))

                        }
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.storyLineStep}>
            <Button
              variant="secondary"
              className={styles.backButton}
              onClick={onBack}
            >
               <i className={cx(styles.icon, "cleverstory-left")}/>
               Back
            </Button>
            <div className={styles.container}>
                <div className={styles.header}>
                    <span className={styles.headerTitle}>Storyline</span>
                    <div className={styles.pageOverview}>
                      <span className={styles.title}>Landing Page Outline</span>
                      <span className={styles.subtitle}>
                        Celebrate with us at the annual Winter Gala and relive the year's highlights.
                      </span>
                    </div>
                </div>

                <div className={styles.outlineContainer}>
                    <DraggableAccordionSections storyLines={outline} />
                </div>
            </div>
            <FooterStep handleContinue={handleContinue} step={2} loading={themeLoading} />
        </div>
    );
}
